import { useEffect, useMemo, useReducer } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import initState from "./initState";
import reducer from "./reducers";
import Landing from "./pages/Landing";
import Bio from "./pages/Bio";
import { getRepos } from "./services/ghHandler";
import { profile } from "./data/profile";
import { isRepoVisible } from "./data/repoVisibility";

const calculateStats = (repos) =>
  repos.reduce(
    (acc, repo) => {
      acc.stars += repo.stargazers_count || 0;
      acc.forks += repo.forks_count || 0;
      acc.projects += 1;
      return acc;
    },
    { stars: 0, forks: 0, projects: 0 }
  );

function App() {
  const [state, dispatch] = useReducer(reducer, {}, initState);

  useEffect(() => {
    let isMounted = true;

    const loadRepos = async () => {
      dispatch({ type: "getRepos" });

      try {
        const repos = await getRepos();
        if (isMounted) {
          dispatch({ type: "updateRepos", item: repos });
        }
      } catch (error) {
        if (isMounted) {
          dispatch({ type: "reposError", error: error.message });
        }
      }
    };

    loadRepos();

    return () => {
      isMounted = false;
    };
  }, []);

  const visibleRepos = useMemo(
    () => state.projects.filter((repo) => isRepoVisible(repo)),
    [state.projects]
  );
  const stats = useMemo(() => calculateStats(visibleRepos), [visibleRepos]);

  return (
    <Router>
      <Switch>
        <Route exact path="/bio">
          <Bio profile={profile} repos={visibleRepos} stats={stats} />
        </Route>
        <Route path="/">
          <Landing
            profile={profile}
            repos={visibleRepos}
            loading={state.loading}
            error={state.error}
            stats={stats}
          />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
